<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="600px"
    scrollable
    v-if="display"
  >
    <v-card min-height="200px">
      <v-card-title>
        <div class="headline">
          Avis du représentant du parcours officine
        </div>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            ><span class="text-subtitle-2">Avis:</span>&nbsp;
            {{ avis.avis ? "Favorable" : "Défavorable" }}
          </v-col>
          <v-col
            ><span class="text-subtitle-2">Date:</span>&nbsp;
            {{ getDate(avis.date) }}
          </v-col>
        </v-row>
        <v-row v-if="avis.visite && avis.visite.compteRendu">
          <v-col>
            <span class="text-subtitle-2">
              Télécharger le compte-rendu de visite:
            </span>
            &nbsp;
            <a :href="getCRURL()" class="subtitle-2" download>
              {{ avis.visite.compteRendu.name }}
            </a>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          class="white--text"
          @click="displayed = false"
          color="primary"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import common from "@/common";
import ApiAvisRPORepository from "@/repositories/ApiAvisRPORepository";

export default {
  name: "ModalVoirAvisRPO",
  props: ["avis", "display"],
  computed: {
    displayed: {
      get() {
        return this.display;
      },
      set(value) {
        this.$emit("update:display", value);
      }
    }
  },
  methods: {
    getDate(timestamp) {
      return common.formatDate(timestamp);
    },
    getCRURL() {
      return ApiAvisRPORepository.getCRURL(this.avis.id);
    }
  }
};
</script>
